import { inject, injectable } from 'inversify';

import { History } from '@vk-hr-tek/core/history';
import { RoleService } from '@vk-hr-tek/core/http';

import { Widget as WidgetGen } from '@app/gen/dashboard';

import { SettingsAccountRouter } from '../../../settings/types';
import { modules } from '../../modules';

@injectable()
export class SettingsAccountRouterService implements SettingsAccountRouter {
  constructor(
    @inject(History) private history: History,
    @inject(RoleService) private readonly role: RoleService,
  ) {}

  goBack(prevState: { pathname: string; search: string }) {
    this.history.push(prevState);
  }

  goToAccountSettings(id: string) {
    this.history.push(
      `/${this.role.get()}/${modules.settings.basename}/${
        modules.account.basename
      }?account_id=${id}`,
    );
  }

  goToRoleModel(id: string) {
    this.history.push(
      `/${this.role.get()}/${modules.settings.basename}/${
        modules.account.basename
      }/${id}/role-model`,
    );
  }

  goToRoleModelExceptions(id: string) {
    this.history.push(
      `/${this.role.get()}/${modules.settings.basename}/${
        modules.account.basename
      }/${id}/role-model/exceptions`,
    );
  }

  goToAddRoleModelExceptions(id: string) {
    this.history.push(
      `/${this.role.get()}/${modules.settings.basename}/${
        modules.account.basename
      }/${id}/role-model/exceptions/add`,
    );
  }

  goToAccountDashboard(id: string) {
    this.history.push(
      `/${this.role.get()}/${modules.settings.basename}/${
        modules.account.basename
      }/${id}/dashboard`,
    );
  }

  goToAccountExceptionDashboard(id: string, exceptionId: string) {
    this.history.push(
      `/${this.role.get()}/${modules.settings.basename}/${
        modules.account.basename
      }/${id}/dashboard/exception/${exceptionId}`,
    );
  }

  goToAccountWidget(
    id: string,
    widgetId: string,
    widgetType: WidgetGen['type'],
  ) {
    this.history.push(
      `/${this.role.get()}/${modules.settings.basename}/${
        modules.account.basename
      }/${id}/dashboard/${widgetId}/${widgetType}`,
    );
  }

  goToAccountDashboardExceptions(id: string) {
    this.history.push(
      `/${this.role.get()}/${modules.settings.basename}/${
        modules.account.basename
      }/${id}/dashboard/exceptions`,
    );
  }

  goToBusinessTripsExceptions(id: string) {
    this.history.push(
      `/${this.role.get()}/${modules.settings.basename}/${
        modules.account.basename
      }/${id}/business-trips/exceptions`,
    );
  }

  goToAddBusinessTripsExceptions(id: string) {
    this.history.push(
      `/${this.role.get()}/${modules.settings.basename}/${
        modules.account.basename
      }/${id}/business-trips/exceptions/add`,
    );
  }

  goToAccountUsersGroups(id: string) {
    this.history.push(
      `/${this.role.get()}/${modules.settings.basename}/${
        modules.account.basename
      }/${id}/groups`,
    );
  }

  goToAccountUsersGroupCreation(id: string) {
    this.history.push(
      `/${this.role.get()}/${modules.settings.basename}/${
        modules.account.basename
      }/${id}/groups/add`,
    );
  }

  goToAccountUsersGroupAssign(id: string) {
    this.history.push(
      `/${this.role.get()}/${modules.settings.basename}/${
        modules.account.basename
      }/${id}/groups/assign`,
    );
  }
}
